export default __webpack_public_path__ + "static/media/318.c30dd66a.jpg";